import api from "./apiHelper";
import { queryCache } from "react-query";
import { useCustomPaginatedQuery, useCustomQuery } from "hooks/reactQuery";

export const useGetGoalReport = (query, onError) => {
  const getLeads = (key, query) => {
    return api.get(`/goal-report/aggregation`, {
      params: { ...query },
    });
  };
  return useCustomPaginatedQuery("data", getLeads, query, {
    onError,
  });
};

export const getGoalReport = (goalId) => {
  return api
    .get(`/goal-report/${goalId}`)
    .then((res) => res)
    .catch((err) => err);
};
